import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { VisionSummarySwapTotalComponent } from "./vision-summary-swap-total.component";

@NgModule({
	declarations: [VisionSummarySwapTotalComponent],
	imports: [CoreModule],
	exports: [VisionSummarySwapTotalComponent]
})
export class VisionSummarySwapTotalModule {}
